import { render, staticRenderFns } from "./ArtistsEvent.vue?vue&type=template&id=4506b215&"
import script from "./ArtistsEvent.vue?vue&type=script&lang=js&"
export * from "./ArtistsEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports